import * as IF from "infrontjs";
import { AuthState } from "../base/AuthState";
import { initHeroShader, destroyHeroShader } from '../../components/hero-shader';

import template from './LoginTemplate.html';
import { IndexState } from "../index/IndexState";

export class LoginState extends AuthState
{
    static ROUTE = '/login';
    static ID = 'login';

    async enter()
    {
        const mainWrapper = this.app.container.querySelector('#main-wrapper' );
        this.app.view.render(
            mainWrapper,
            template
        );

        initHeroShader( mainWrapper.querySelector( '#hero-shader' ) );

        // Pre-select saved region
        const savedRegion = this.app.storage.loadRegion();
        if ( savedRegion )
        {
            mainWrapper.querySelector( '[data-id="select-region"]' ).value = savedRegion;
        }

        this.addEventListener(
            mainWrapper.querySelector( '[data-id="btn-login"]' ),
            'click',
            async ( e ) => {
                mainWrapper.querySelector( '[data-id="login-error-container"]' ).style.display = 'none';
                const form = mainWrapper.querySelector( '[data-id="form-login"]' );
                if ( true === form.checkValidity() )
                {
                    mainWrapper.querySelector( '[data-id="btn-login"]' ).style.display = 'none';
                    mainWrapper.querySelector( '[data-id="btn-login-loading"]' ).style.display = 'block';
                    const credentials = IF.Helper.serializeForm( form );

                    // Save region and update API endpoint
                    this.app.storage.saveRegion( credentials.region );
                    this.app.api.setRegion( credentials.region );

                    try
                    {
                        const { result } = await this.app.api.post(
                            '/auth/session',
                            {
                                email : credentials.email,
                                password: credentials.password
                            }
                        );

                        if ( result && +result.status === 201 )
                        {
                            this.app.storage.saveSessionToken( result.data.token );
                            await this.app.resolveSession();
                            this.app.router.redirect( IndexState.ROUTE );
                        }
                        else
                        {
                            throw new Error();
                        }
                    }
                    catch( e )
                    {
                        switch ( +e.status )
                        {
                            case 401:
                            case 403:
                                mainWrapper.querySelector( '[data-id="login-error-container"]' ).innerText = 'Invalid credentials';
                            break;

                            case 404:
                                mainWrapper.querySelector( '[data-id="login-error-container"]' ).innerText = 'Email not found';
                            break;

                            default:
                                mainWrapper.querySelector( '[data-id="login-error-container"]' ).innerText = 'Error logging in. Please try again later.';
                        }
                        mainWrapper.querySelector( '[data-id="login-error-container"]' ).style.display = 'block';
                    }
                    mainWrapper.querySelector( '[data-id="btn-login-loading"]' ).style.display = 'none';
                    mainWrapper.querySelector( '[data-id="btn-login"]' ).style.display = 'block';
                }
                else
                {
                    form.classList.add('was-validated');
                }
            }
        );
    }

    async exit()
    {
        destroyHeroShader();
    }
}
